const Logo = () => {
    return (<img src="/aihn-logo.svg" alt="logo" className="w-12 h-12"/>);
}

export default Logo